/* eslint-disable @typescript-eslint/naming-convention */
import { APP_LANGUAGES } from '../../services';

export enum Language {
  De = 'DE',
  Cs = 'CS',
  En = 'EN',
  Es = 'ES',
  Fr = 'FR',
  Hu = 'HU',
  Sk = 'SK',
  It = 'IT',
  Ja = 'JA',
  Pl = 'PL',
  Pt = 'PT',
  Ro = 'RO',
  Uk = 'UK',
  Ru = 'RU',
  Zh = 'ZH',
  Hi = 'HI',
  Th = 'TH',
  Tr = 'TR',
  Sr = 'SR',
  Pt_Br = 'PT_BR',
}

export const LANGUAGE_BY_DEFAULT = Language.En;
export const BROWSER_LANGUAGE_MAP: Map<string, Language> = new Map<string, Language>([
  ['de', Language.De],
  ['cs', Language.Cs],
  ['en', Language.En],
  ['es', Language.Es],
  ['fr', Language.Fr],
  ['hu', Language.Hu],
  ['sk', Language.Sk],
  ['sr', Language.Sr],
  ['it', Language.It],
  ['ja', Language.Ja],
  ['pl', Language.Pl],
  ['pt', Language.Pt],
  ['ro', Language.Ro],
  ['uk', Language.Uk],
  ['zh', Language.Zh],
  ['hi', Language.Hi],
  ['ru', Language.Ru],
  ['th', Language.Th],
  ['tr', Language.Tr],
  ['pt_br', Language.Pt_Br],
]);

export function getSortedLanguageList(defaultLanguage?: Language): Language[] {
  const languageList: Language[] = APP_LANGUAGES;
  const mostUsedLanguages: Language[] = [Language.En, Language.De, Language.Fr];
  const withoutDefault: Language[] = defaultLanguage
    ? languageList.filter((language: Language) => language !== defaultLanguage)
    : languageList;
  const mostUsed: Language[] = mostUsedLanguages.filter(
    (language: Language) => language !== defaultLanguage && withoutDefault.includes(language),
  );
  const remaining: Language[] = withoutDefault.filter((language: Language) => !mostUsed.includes(language));
  const sortedRemaining: Language[] = remaining.sort((a: Language, b: Language) => a.localeCompare(b));

  return defaultLanguage ? [defaultLanguage, ...mostUsed, ...sortedRemaining] : [...mostUsed, ...sortedRemaining];
}
